import { useState } from "react";
import { motion } from "framer-motion";
import { Upload, FileText } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";

export const StepDocuments = ({ tr, files, setFiles }) => {
  const [dragOver, setDragOver] = useState(false);
  
  const handleDrop = e => {
    e.preventDefault();
    setDragOver(false);
    setFiles(prev => [...prev, ...Array.from(e.dataTransfer.files)]);
  };
  
  const handleSelect = e => {
    setFiles(prev => [...prev, ...Array.from(e.target.files)]);
  };
  
  return (
    <motion.div initial={{ opacity: 0, x: 20 }} animate={{ opacity: 1, x: 0 }} exit={{ opacity: 0, x: -20 }} className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold text-primary font-['Manrope'] mb-2">{tr.documents.title}</h2>
        <p className="text-muted-foreground">{tr.documents.description}</p>
        <Badge variant="secondary" className="mt-2">{tr.documents.optional}</Badge>
      </div>
      <div 
        className={`upload-zone ${dragOver ? 'dragover' : ''}`} 
        onDragOver={e => {e.preventDefault(); setDragOver(true);}} 
        onDragLeave={() => setDragOver(false)} 
        onDrop={handleDrop} 
        onClick={() => document.getElementById('file-input').click()} 
        data-testid="file-upload-zone"
      >
        <Upload className="w-12 h-12 text-muted-foreground mx-auto mb-4" />
        <p className="text-foreground font-medium">{tr.documents.dragDrop}</p>
        <p className="text-sm text-muted-foreground mt-2">{tr.documents.acceptedFormats}</p>
        <input id="file-input" type="file" multiple className="hidden" onChange={handleSelect} data-testid="file-input" />
      </div>
      {files.length > 0 && (
        <div className="space-y-2">
          {files.map((f,i) => (
            <div key={i} className="flex items-center justify-between p-3 bg-muted rounded-lg">
              <div className="flex items-center gap-3">
                <FileText className="w-5 h-5 text-muted-foreground" />
                <span className="text-sm font-medium">{f.name}</span>
                <span className="text-xs text-muted-foreground">({(f.size/1024).toFixed(1)} KB)</span>
              </div>
              <Button variant="ghost" size="sm" onClick={e => {e.stopPropagation(); setFiles(prev => prev.filter((_,idx) => idx !== i));}} data-testid={`remove-file-${i}`}>×</Button>
            </div>
          ))}
        </div>
      )}
    </motion.div>
  );
};
